import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowDrawer: Components<Theme>['MuiDrawer'] = {
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      flexShrink: '0',
      // add smooth transition for opening/closing drawer in persistent variant
      ...(ownerState.variant === 'persistent'
        ? {
            transition: theme.transitions.create('width', {
              duration: theme.transitions.duration[ownerState.open ? 'leavingScreen' : 'enteringScreen'],
            }),
          }
        : {}),
    }),
    paper: ({ theme }) => ({
      boxShadow: theme.flowShadows.xl,
      ...(theme.palette.mode === 'dark' && {
        backgroundImage: 'none',
      }),
    }),
  },
};
